(() => {
  'use strict';

  const configNode = document.getElementById('NAAYNativeVariantUXData');
  if (!configNode) return;

  let config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (_) {
    return;
  }

  const variants = Array.isArray(config.variants) ? config.variants : [];
  const variantByOptions = new Map(
    variants.map((variant) => [JSON.stringify(variant.options || []), variant])
  );

  const colorIndex = Number(config.colorOptionIndex);
  const colorMedia = new Map();
  const conflicts = new Set();

  if (Number.isInteger(colorIndex) && colorIndex >= 0) {
    for (const variant of variants) {
      const color = variant?.options?.[colorIndex];
      const media = variant?.media;
      if (!color || !media?.id) continue;

      const prev = colorMedia.get(color);
      if (!prev) {
        colorMedia.set(color, media);
      } else if (String(prev.id) !== String(media.id)) {
        conflicts.add(color);
      }
    }
    for (const color of conflicts) colorMedia.delete(color);
  }

  function selectedValue(target) {
    if (target?.tagName === 'SELECT') {
      const selected = target.selectedOptions?.[0];
      return selected ? selected.value || selected.textContent.trim() : '';
    }
    return target?.value || '';
  }

  function getField(target) {
    return target?.closest?.('[data-picker-field]') || null;
  }

  function getProductInfo(target) {
    return target?.closest?.('product-info')
      || document.querySelector("product-info[id^='MainProduct']")
      || document.querySelector('product-info');
  }

  function getGallery(target) {
    const productInfo = getProductInfo(target);
    return productInfo?.querySelector("media-gallery[id^='MediaGallery-']")
      || productInfo?.querySelector('media-gallery')
      || document.querySelector("media-gallery[id^='MediaGallery-']")
      || document.querySelector('media-gallery');
  }

  function getPicker(target) {
    return target?.closest?.('variant-picker') || null;
  }

  function updateOptimisticLabel(target) {
    const field = getField(target);
    if (!field) return null;

    const value = selectedValue(target);
    if (!value) return field;

    field.dataset.selectedValue = value;
    const label = field.querySelector('.option-label--selected');
    if (label) label.textContent = value;
    return field;
  }

  function currentOptionValues(picker) {
    if (!picker) return [];

    return [...picker.querySelectorAll('[data-picker-field]')].map((field) => {
      const select = field.querySelector('select');
      if (select) return selectedValue(select);

      const checked = field.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value || '';

      return field.dataset.selectedValue || '';
    });
  }

  function resolveCurrentVariant(target) {
    const picker = getPicker(target);
    const values = currentOptionValues(picker);
    if (!values.length || values.some((value) => !value)) return null;
    return variantByOptions.get(JSON.stringify(values)) || null;
  }

  function updateOptimisticPrice(target) {
    const variant = resolveCurrentVariant(target);
    if (!variant?.price) return null;

    const productInfo = getProductInfo(target);
    const priceRoot = productInfo?.querySelector('[id^="Price-"]');
    if (!priceRoot) return variant;

    const regularPrice = priceRoot.querySelector('.m-price__regular .m-price-item--regular');
    const salePrice = priceRoot.querySelector('.m-price__sale .m-price-item--sale');

    if (regularPrice) regularPrice.textContent = variant.price;
    if (salePrice) salePrice.textContent = variant.price;

    return variant;
  }

  function switchColorMedia(field, target) {
    if (!field || field.dataset.optionName !== '顏色') return;

    const value = selectedValue(target);
    const media = colorMedia.get(value);
    if (!media) return;

    const gallery = getGallery(target);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    gallery.setActiveMedia({
      featured_media: {
        id: media.id,
        position: media.position || 1
      }
    });
  }

  // Delegated capture listener survives MINIMOG replacing <variant-picker>
  // after every section response.
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
    if (!target.closest('variant-picker')) return;

    const field = updateOptimisticLabel(target);
    updateOptimisticPrice(target);
    switchColorMedia(field, target);
  }, true);

  window.NAAYNativeVariantUX = {
    handle: config.handle,
    variantCount: variants.length,
    colorMediaCount: colorMedia.size,
    conflictingColors: [...conflicts],
    listenerMode: 'document-delegated-capture',
    optimisticPrice: true
  };
})();